import { jobLabelsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const reducerById = () => (state = {}, action) => {
  switch (action.type) {
    case jobLabelsActionTypes.success:
      return {
        ...state,
        ...action.response
      };
    default:
      return state;
  }
};

const jobBuilds = cachedRequestByIdReducer(
  jobLabelsActionTypes,
  'byId',
  ['request'],
  reducerById
);
export default jobBuilds;

const getJobLabelsState = state => state.jobLabels;
export const jobLabelsByJobId = state => getJobLabelsState(state).byId;
export const getJobLabelsByJobId = (state, id) => {
  const result = jobLabelsByJobId(state)[id];
  return result ? result : [];
};


// WEBPACK FOOTER //
// src/reducers/jobLabels.js